/** Server limits for AIVIA attachments (server-nest attachments.service.ts): 5 MB for PNG/JPEG, 10 MB otherwise. */
export const AGENT_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
export const AGENT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
/** Files AIVIA reads per message (ATTACHMENT_FILES in threads-agent.service.ts, files in agent turn.py). */
export const AGENT_MAX_FILES = 3;

/** Largest size AIVIA accepts for this file, so a too-large file is refused before it uploads. */
export function agentAttachmentLimit(file: Pick<File, 'type'>): number {
  return /^image\/(png|jpeg)$/.test(file.type) ? AGENT_IMAGE_MAX_BYTES : AGENT_ATTACHMENT_MAX_BYTES;
}

/** Rounded up to 0.1, so a file just over a limit never reads as the limit itself. */
export function formatFileSize(bytes: number): string {
  const [value, unit] = bytes >= 1024 * 1024 ? [bytes / (1024 * 1024), 'MB'] : [Math.max(bytes, 1) / 1024, 'KB'];
  const up = Math.ceil(value * 10) / 10;
  return `${Number.isInteger(up) ? up : up.toFixed(1)} ${unit}`;
}
